import styled from "styled-components";

export const FullWidthActionButtons = styled.div`
	& button:not(:last-child) {
		margin-bottom: 1em;
	}
`;
